function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_14",
  "data-name": "Group 14",
  transform: "translate(-2.413 -68.692)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_11",
  "data-name": "Group 11",
  transform: "translate(4.573 69.454) rotate(45)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_10",
  "data-name": "Group 10",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_36",
  "data-name": "Path 36",
  d: "M25.2,78.439H1.061a1.028,1.028,0,1,0,0,2.055H25.2a1.028,1.028,0,1,0,0-2.055Z",
  transform: "translate(0 -78.439)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_13",
  "data-name": "Group 13",
  transform: "translate(23.145 70.852) rotate(135)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_37",
  "data-name": "Path 37",
  d: "M25.2,392.2H1.061a1.028,1.028,0,1,0,0,2.055H25.2a1.028,1.028,0,1,0,0-2.055Z",
  transform: "translate(0 -392.197)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
}))));

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.44,
    height: 21.495,
    viewBox: "0 0 21.44 21.495",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cross.3d1d5c36.svg";
export { ForwardRef as ReactComponent };